import $ from 'jquery'
import manager from '../manager'
import EventBus from '@/utils/iframe-eventbus'

let index = 0

manager.add('tab', {
  created(evenType) {
    this.evenType=evenType||'click'
    var $dom = $(this.dom);
    var $content = $dom.find('.J_tab-content>div');
    var tabs = $dom.find(".J_tab-header li")
    var self = this;
    var type = $dom.attr('data-type');

    $dom.on('click', '.J_tab-header', function(e) {
      EventBus.dispatch("activeModule", { instanceId: self.instanceId, flag: "TabCategory" })
    })

    $dom.on(this.evenType, '.J_tab-header li', function(e) {
      index = $(this).index()
      $(window).trigger("scroll")
      EventBus.dispatch("tabModule/change", {
        id: self.instanceId,
        index
      })

    })
    this.onTab = function(e) {      
      if(e.target.id!=self.instanceId)return
      var tab = tabs.eq(e.target.index)
      tab.addClass('active').siblings('li').removeClass('active')
      $content.removeClass('active').eq(e.target.index).addClass('active');
      if (type === 'image' || type === 'text_image') {
        let $img = tab.find('img');
        let selectImage = $img.attr('data-select');
        $img.attr('src', selectImage);
        tab.siblings('li').each(function() {
			let $img = $(this).find('img');
			let defaultImage = $img.attr('data-default');
			$img.attr('src',defaultImage)
        })
      }
    }
    this.onTab({ target: { index,id: self.instanceId } })
    EventBus.addEventListener("tabModule/change", this.onTab)
  },
  destroyed() {
    $(this.dom).off('click', '.J_tab-header')
    $(this.dom).off(this.evenType, '.J_tab-header li')
    EventBus.removeEventListener("tabModule/change", this.onTab)
  }
})
